import { AppRouter } from './router/AppRouter'

/**
 * Uyyamadilu storefront app.
 * Routing + context providers live in AppRouter; this is just the shell.
 */
export function App(): JSX.Element {
  return <AppRouter />
}
